import React from 'react';
import { withTranslation } from 'react-i18next';
import { Alert } from '@mui/material';
import { Snackbar, useMediaQuery } from '@mui/material';
import { theme } from '../../../WhiteLabels/Templates/Template1/Template';
// components
import 'src/assets/stylesheet/CardSectionStyle.css';

function AlertMessage(props) {
    const {i18n, message,alertType,closeAlert,disableAutoHide,t, snackOpen,...other } = props;
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const vertical = matches ? 'bottom' : 'top';

    return(
        <Snackbar
            open={snackOpen}
            autoHideDuration={disableAutoHide ? null : 3000}
            anchorOrigin={{ vertical, horizontal:'center' }}
            key={`${vertical} center`}
            onClose={closeAlert}
            >
            <Alert {...other} style={{fontFamily,textTransform:'capitalize'}} severity={alertType ? alertType : ''}>
                {message}
            </Alert>
        </Snackbar>
    )
}

export default withTranslation('common')(AlertMessage);